import React from "react";
import LOGO_BLUE from "../../../assets/v4-reports-assets/images/logo-blue.png";
import REPLACE_ROOF from "../../../assets/v4-reports-assets/images/section-one/replace-roof-graphic.png";
import REPLACE_ROOF_ICON from "../../../assets/v4-reports-assets/icons/replace-roof-icon.png";
import CLAIM_COVERAGE from "../../../assets/v4-reports-assets/images/section-one/claim-coverage-graphic.png";
import CLAIM_COVERAGE_ICON from "../../../assets/v4-reports-assets/icons/claim-coverage-icon.png";
import REPORT_DAMAGE from "../../../assets/v4-reports-assets/images/section-one/report-damage-graphic.png";
import REPORT_DAMAGE_ICON from "../../../assets/v4-reports-assets/icons/report-damage-icon.png";
import CLAIMS_PROCESS from "../../../assets/v4-reports-assets/images/claims-process.png";
import NEXT_STEPS_BG from "../../../assets/v4-reports-assets/images/next-steps-bg.png";

const Section3 = (props) => {
  return (
    <>
      <section
        style={{
          background: `url(${NEXT_STEPS_BG})`,
          backgroundSize: "cover",
          height: "100vh",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          // paddingBottom: "3rem",
          paddingTop: "58rem",
        }}
        class=""
      ></section>
    </>
  );
};

export default Section3;

{
  /* <div class="body-section-one__content-box">
<div class="body-section-one__content-box--header">
  <div class="logo">
    <img
      src={LOGO_BLUE}
      alt="remote roofing logo"
      class="actual-image"
    />
  </div>
  <h2 class="title">Next Steps</h2>
</div>
<div>
  <img src={CLAIMS_PROCESS} />
</div>
</div> */
}

{
  /* <div class="body-section-one__content-box--body">
<div class="container">
  <div class="body-item">
    <img src={REPORT_DAMAGE} alt="" class="body-item-graphic" />
    <div class="body-item-name">
      <img src={REPORT_DAMAGE_ICON} alt="" class="item-icon" />
      <p class="item-actual-name">Report Damage</p>
    </div>
  </div>
  <div class="body-item">
    <img src={CLAIM_COVERAGE} alt="" class="body-item-graphic" />
    <div class="body-item-name">
      <img src={CLAIM_COVERAGE_ICON} alt="" class="item-icon" />
      <p class="item-actual-name">Claim Coverage</p>
    </div>
  </div>
  <div class="body-item">
    <img src={REPLACE_ROOF} alt="" class="body-item-graphic" />
    <div class="body-item-name">
      <img src={REPLACE_ROOF_ICON} alt="" class="item-icon" />
      <p class="item-actual-name">Replace Roof</p>
    </div>
  </div>
</div>
</div> */
}
